import { render, staticRenderFns } from "./speaker.vue?vue&type=template&id=4b2f2cd8&scoped=true&"
import script from "./speaker.vue?vue&type=script&lang=js&"
export * from "./speaker.vue?vue&type=script&lang=js&"
import style0 from "./speaker.vue?vue&type=style&index=0&id=4b2f2cd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f2cd8",
  null
  
)

export default component.exports